import React, { createContext, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { getRouteSEO } from "../utils/canonicalUtils";

export const RouteSEOContext = createContext(false);

const pageTitles = {
  "/terms": "Terms & Conditions - Sea What You Save",
  "/privacy": "Privacy Policy - Sea What You Save",
  "/giveaway-rules": "Giveaway Rules - Sea What You Save",
  "/sign-in": "Sign In - Sea What You Save",
};

const RouteSEO = ({ children }) => {
  const { pathname, search } = useLocation();
  const { canonical, robots } = getRouteSEO(pathname, search);

  useLayoutEffect(() => {
    document.title = pageTitles[pathname.replace(/\/+$/, "")] || "Sea What You Save";
  }, [pathname]);

  useLayoutEffect(() => {
    const canonicalTags = [...document.querySelectorAll('link[rel="canonical"]')];
    let canonicalTag = canonicalTags.shift();
    canonicalTags.forEach((tag) => tag.remove());
    if (canonical) {
      if (!canonicalTag) {
        canonicalTag = document.createElement("link");
        canonicalTag.rel = "canonical";
        document.head.appendChild(canonicalTag);
      }
      if (canonicalTag.getAttribute("href") !== canonical) canonicalTag.setAttribute("href", canonical);
    } else {
      canonicalTag?.remove();
    }

    let robotsTag = document.querySelector('meta[name="robots"]');
    if (!robotsTag) {
      robotsTag = document.createElement("meta");
      robotsTag.name = "robots";
      document.head.appendChild(robotsTag);
    }
    robotsTag.content = robots;
  }, [canonical, robots]);

  return <RouteSEOContext.Provider value={true}>{children}</RouteSEOContext.Provider>;
};

export default RouteSEO;
